import React from "react";
import MainSkeleton from "./MainSkeleton";

const ProjectSkeleton = () => {
  return (
    <div className=" project-skeleton">
      <MainSkeleton
        type={"img"}
        classes={"w-full h-[20rem] sm:h-[24rem]"}
      />
      <div className="flex justify-between gap-3 items-center mt-8">
        <MainSkeleton type={"title"} classes= {"w-full h-[36px]"}/>
        <div className="flex items-center gap-2">
          <MainSkeleton type={"link"} classes = "h-[36px]"/>
          <MainSkeleton type={"link"} classes = "h-[36px]"/>
        </div>
      </div>
      <div className="flex gap-3">
    <MainSkeleton type={'text'} classes = 'h-[32px]'/>
    <MainSkeleton type={'text'} classes = 'h-[32px]'/>
    <MainSkeleton type={'text'} classes = 'h-[32px]'/>
    <MainSkeleton type={'text'} classes = 'h-[32px]'/>

      </div>
    </div>
  );
};

export default ProjectSkeleton;
